import { useEffect } from "react";
import DigitalCouponRedeemInstructions from "../Items/Details/Digital/Instruction";
import ProductItem from "../Items/ProductItem";
import "./product-list.css";

export default function ProductList({
  coupons,
  handleCoupons,
  currPage,
  isRedeemedOneCoupon,
}) {
  useEffect(() => {
    document.getElementById("product-list").scrollTo({
      top: 0,
      behavior: "smooth", // optional
    });
  }, [currPage]);
  return (
    <div className="mc-product-list" id="product-list">
      <div>
        {coupons &&
          (coupons?.rows || coupons).map((item, index) => {
            return (
              <ProductItem
                coupon={item}
                index={index}
                handleCoupons={handleCoupons}
                currPage={currPage}
                isRedeemedOneCoupon={isRedeemedOneCoupon}
              />
            );
          })}
        {coupons &&
          coupons[0]?.type === "digital" &&
          coupons[0]?.brand_name?.toLowerCase() === "amazon" && (
            <DigitalCouponRedeemInstructions />
          )}
      </div>
    </div>
  );
}
